/* eslint-disable react-hooks/exhaustive-deps */
import {
  Grid,
  Stack,
  Typography,
  Box,
  Autocomplete,
  TextField,
  CircularProgress,
  InputAdornment,
  Button,
} from "@mui/material";
import { Controller, useForm, useWatch } from "react-hook-form";
import { FormCheckBox, FormTextInput } from "../../../components/form";

import { useEffect, useRef, useState } from "react";
import { InternationalPhone } from "../../../components/common/InternationalPhone";
import { useOrganizationContext } from "../../../contexts/OrganizationContext";
import { useSessionContext } from "../../../contexts/SessionContext";
import { useLocationContext } from "../../../contexts/LocationContext";
import { GetAddressByCep } from "../../../services/viaCep/GetCep";
import { useFormatter } from "../../../utils/useFormatter";
import { RequiredField } from "./RequiredField";
import { SelectLocation } from "./SelectLocation";
import { SubmitActions } from "./SubmitActions";
import { Close } from "@mui/icons-material";
import { useValueSet } from "../../../hooks/useValueSet";
import { UFValueSet } from "../../../utils/useValueSet";

export function Location({
  onNext,
  defaultValues,
  setCurrentStep,
  create,
  handleClose,
  editData,
  setEditData = () => {},
}: any) {
  const { roles } = useSessionContext();
  const { organization, typeOrganization } = useOrganizationContext();
  const { location, refetchLocation } = useLocationContext();
  const [loading, setLoading] = useState(false);
  const [loadingCep, setLoadingCep] = useState(false);
  const { control, handleSubmit, getValues, setValue, setError, clearErrors } =
    useForm({
      defaultValues,
    });
  const [selectedTab, setSelectedTab] = useState("1");

  const locationFilled = useWatch({ name: "locationFilled", control });

  const [locationSelected, setLocationSelected] = useState(
    locationFilled ?? false
  );

  const watchedFieldAddress = useWatch({ name: "addressForm", control });
  const watchedFieldName = useWatch({ name: "nameCNPJ", control });

  const fieldsAddressForm: Array<string> = [
    "city",
    "state",
    "cep",
    "zone",
    "street",
    "number",
    "complement",
  ];

  const watchedAddressValues = useWatch({
    control,
    name: fieldsAddressForm,
  });

  const isAddressFilled = watchedAddressValues.some(
    (val: any) => val && val !== ""
  );

  const numberInputRef = useRef<HTMLInputElement>(null);
  const [numberFocus, setNumberFocus] = useState(false);

  // Estado e hook para autocomplete de cidades
  const [citySearchTerm, setCitySearchTerm] = useState("");
  const { options: cityOptions, loading: isLoadingCities } = useValueSet({
    valueSet: "",
    customUrl: "1.3.6.1.4.1.54413.1.1.6.12",
    searchTerm: citySearchTerm,
    debounceTime: 300,
  });

  const nameEqualCNPJ = (roles: any) => {
    const nameOrganization =
      organization?.alias?.[0] !== "null"
        ? organization?.alias?.[0]
        : organization?.name;

    if (getValues("nameCNPJ") === true) {
      setValue("nameCNPJ", true);
      setValue("name", nameOrganization);
    } else {
      setValue("nameCNPJ", false);
      setValue("name", ""); //TODO verificar bug troca checkbox endereço
    }
  };

  const addressEqualCNPJ = (roles: any) => {
    const addressOrganization = organization?.contact?.find(
      (el: any) => el.address
    )?.address;

    const city = addressOrganization?.city || "";
    const line = addressOrganization?.line || "";
    const postalCode = addressOrganization?.postalCode || "";
    const state = addressOrganization?.state || "";

    const fieldsAddress: Array<string> = fieldsAddressForm;

    const valuesOrganization: Array<string> = [
      city,
      state,
      postalCode,
      line?.[0],
      line?.[1],
      line?.[2],
      line?.[3],
    ];

    if (getValues("addressForm") === true) {
      fieldsAddress.map((el, index) =>
        setValue(`${el}`, valuesOrganization[index])
      );
    } else {
      fieldsAddress.map((el) => setValue(`${el}`, ""));
    }
  };

  const addressEqualPostalCode = async (data: any) => {
    const cep = data?.replace(/[^0-9]/g, "");

    if (cep?.length === 8) {
      setLoadingCep(true);
      try {
        const addressResponse = await GetAddressByCep(cep);

        const city = addressResponse?.localidade || "";
        const postalCode = addressResponse?.cep || "";
        const state = addressResponse?.uf || "";
        const street = addressResponse?.logradouro || "";
        const zone = addressResponse?.bairro || "";
        const complement = addressResponse?.complemento || "";

        const fieldsAddress: Array<string> = fieldsAddressForm;

        const valuesAddressPostalCode: Array<string> = [
          city,
          state,
          postalCode,
          zone,
          street,
          "",
          complement,
        ];

        if (addressResponse?.erro) {
          setError("cep", {
            type: "custom",
            message: "CEP Inválido ou não encontrado! digite um CEP válido",
          });
          setNumberFocus(false);
        } else {
          fieldsAddress.map((el, index) =>
            setValue(`${el}`, valuesAddressPostalCode[index])
          );
          setNumberFocus(true);
        }
      } finally {
        setLoadingCep(false);
      }
    } else {
      setError("cep", {
        type: "custom",
        message: "CEP Inválido! digite um CEP válido",
      });
      setNumberFocus(false);
    }
  };

  const clearAddressFields = () => {
    fieldsAddressForm.forEach((field) => setValue(field, ""));
    setCitySearchTerm("");
    setValue("addressForm", false);
  };

  const onSubmit = async (data: any) => {
    setLoading(true);

    if (create) {
      await create(data);
    } else {
      await onNext({ location: data });
      setCurrentStep((prev: number) => prev + 1);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (watchedFieldName === true || watchedFieldAddress === true) {
      nameEqualCNPJ(roles);
      addressEqualCNPJ(roles);
    }
  }, [watchedFieldName, watchedFieldAddress]);

  useEffect(() => {
    if (numberFocus && numberInputRef.current) {
      numberInputRef.current.focus();
    }
  }, [numberFocus]);

  if (!locationSelected && !create) {
    return (
      <SelectLocation
        setLocationSelected={setLocationSelected}
        setCurrentStep={setCurrentStep}
        handleSubmit={handleSubmit(onSubmit)}
        onSubmit={onSubmit}
        setValue={setValue}
        getValues={getValues}
        refetchLocation={refetchLocation}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
    );
  }

  return (
    <Stack width="100%" spacing={2} mb={2}>
      {!create && (
        <Typography
          variant="h6"
          fontWeight="600"
          color="neutral700.main"
          textAlign="center"
          padding="16px 0px 16px 0px"
        >
          Adicione a localização.
        </Typography>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" fontWeight="600" color="neutral600.main">
            Nome <RequiredField />
          </Typography>
          <Typography variant="body1" fontWeight={400}>
            Esse nome será exibido nas buscas e aparecerá como nome da
            clínica/filial
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <FormCheckBox
            name="nameCNPJ"
            control={control}
            defaultValue={false}
            label={
              typeOrganization !== "bus"
                ? "Mesmo nome usado no CNPJ"
                : "Utilizar nome de exibição"
            }
            checked={watchedFieldName}
          />
        </Grid>
        <Grid item xs={12}>
          <FormTextInput
            name="name"
            label=""
            placeholder="Nome usado para essa localização"
            control={control}
            required
            autoFocus
            hiddenLabel={true}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} paddingTop={2}>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h6" fontWeight="600" color="neutral600.main">
                Endereço <RequiredField />
              </Typography>
              {typeOrganization === "bus" && isAddressFilled && (
                <Button
                  variant="text"
                  size="small"
                  color="error"
                  startIcon={<Close />}
                  onClick={clearAddressFields}
                  sx={{ textTransform: "none" }}
                >
                  Limpar endereço
                </Button>
              )}
            </Box>
          </Grid>

          {typeOrganization !== "bus" && (
            <Grid item xs={12}>
              <Box display="flex" flexDirection="row" alignItems="center">
                <FormCheckBox
                  name="addressForm"
                  control={control}
                  defaultValue={false}
                  label="Mesmo endereço do CNPJ"
                  checked={watchedFieldAddress}
                />
                {isAddressFilled && (
                  <Button
                    variant="text"
                    size="small"
                    color="error"
                    startIcon={<Close />}
                    onClick={clearAddressFields}
                    sx={{ textTransform: "none", ml: 2 }}
                  >
                    Limpar endereço
                  </Button>
                )}
              </Box>
            </Grid>
          )}

          <Grid item lg={2} sm={12}>
            <Controller
              name="cep"
              control={control}
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <TextField
                  label="CEP"
                  variant="filled"
                  value={useFormatter.formatCEP(value)}
                  onChange={(e) => {
                    onChange(useFormatter.formatCEP(e.target.value));
                  }}
                  onBlur={() => addressEqualPostalCode(value)}
                  onFocus={() => clearErrors("cep")}
                  fullWidth
                  error={!!error}
                  helperText={error ? error.message : null}
                  sx={{
                    "& .MuiFilledInput-root": {
                      backgroundColor: "neutral100.main",
                    },
                  }}
                  InputProps={{
                    endAdornment: loadingCep ? (
                      <InputAdornment position="end">
                        <CircularProgress size={20} />
                      </InputAdornment>
                    ) : null,
                  }}
                />
              )}
            />
          </Grid>
          <Grid item lg={4} sm={12}>
            {/* Campo de cidade com autocomplete usando valueset customizado */}
            <Controller
              name="city"
              control={control}
              rules={{ required: true }}
              render={({ field, fieldState }) => {
                // Encontra a opção correspondente ao valor do campo, se existir
                // Busca pelo display (nome da cidade) já que agora salvamos o display
                const selectedOption = cityOptions?.find(
                  (option) => option.display === field.value
                );

                // Se encontrou na lista, usa o objeto; senão usa o valor como string (freeSolo)
                const currentValue = selectedOption || field.value || "";

                return (
                  <Autocomplete
                    freeSolo
                    options={cityOptions || []}
                    loading={isLoadingCities}
                    getOptionLabel={(option) =>
                      typeof option === "string" ? option : option.display || ""
                    }
                    inputValue={
                      typeof currentValue === "string"
                        ? currentValue
                        : currentValue.display || ""
                    }
                    onInputChange={(_, value, reason) => {
                      // Atualiza o termo de busca para autocomplete
                      setCitySearchTerm(value);
                      // Se o usuário digitou (não selecionou), atualiza o campo
                      if (reason === "input") {
                        field.onChange(value);
                      }
                      // Se o usuário limpou o campo (clicou no X), limpa o valor
                      if (reason === "clear") {
                        field.onChange("");
                      }
                    }}
                    onChange={(_, newValue) => {
                      // Se newValue é string (valor personalizado digitado), usa direto
                      // Se é objeto (opção da lista selecionada), pega o display (nome da cidade)
                      if (typeof newValue === "string") {
                        field.onChange(newValue);
                      } else if (newValue) {
                        field.onChange(
                          newValue.display || newValue.code || newValue.value
                        );
                      } else {
                        field.onChange("");
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Cidade *"
                        variant="filled"
                        fullWidth
                        error={!!fieldState.error}
                        sx={{
                          "& .MuiFilledInput-root": {
                            backgroundColor: "neutral100.main",
                          },
                        }}
                      />
                    )}
                  />
                );
              }}
            />
          </Grid>
          <Grid item lg={2} sm={12}>
            <Controller
              name="state"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <Autocomplete
                  options={UFValueSet}
                  getOptionLabel={(option) => option.value}
                  value={
                    UFValueSet.find((item) => item.value === value) || null
                  }
                  onChange={(_, newValue) => {
                    onChange(newValue ? newValue.value : "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Estado"
                      variant="filled"
                      required
                      error={!!error}
                      sx={{
                        "& .MuiFilledInput-root": {
                          backgroundColor: "neutral100.main",
                        },
                      }}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item lg={4} sm={12}>
            <FormTextInput
              name="zone"
              label="Bairro *"
              control={control}
              variant="filled"
              required
            />
          </Grid>

          <Grid item lg={6} sm={12}>
            <FormTextInput
              name="street"
              label="Endereço *"
              control={control}
              variant="filled"
              required
            />
          </Grid>
          <Grid item lg={2} sm={12}>
            <FormTextInput
              inputRef={numberInputRef}
              name="number"
              label="Número *"
              control={control}
              variant="filled"
              required
            />
          </Grid>
          <Grid item lg={4} sm={12}>
            <FormTextInput
              name="complement"
              label="Complemento *"
              control={control}
              variant="filled"
              required
            />
          </Grid>
        </Grid>
      <Grid container spacing={2} paddingTop={2}>
        <Grid item xs={12}>
          <Typography variant="h6" fontWeight="600" color="neutral600.main">
            Telefone
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <InternationalPhone
            name="phoneClinic"
            control={control}
            label="Telefone da localização"
            defaultValue={defaultValues?.phoneClinic}
          />
        </Grid>
      </Grid>
      <SubmitActions
        loading={loading}
        goBack={() => {
          if (create && handleClose) {
            handleClose();
          } else {
            setLocationSelected(false);
          }
          setEditData(false);
        }}
        goForward={handleSubmit(onSubmit)}
      />
    </Stack>
  );
}
